var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5598 1.24727L4.55978 8.24728C4.51914 8.28795 4.47089 8.32022 4.41778 8.34224C4.36467 8.36426 4.30774 8.37559 4.25024 8.37559C4.19275 8.37559 4.13582 8.36426 4.08271 8.34224C4.0296 8.32022 3.98134 8.28795 3.94071 8.24728L0.878212 5.18477C0.796119 5.10268 0.75 4.99134 0.75 4.87524C0.75 4.75915 0.796119 4.6478 0.878212 4.56571C0.960305 4.48362 1.07165 4.4375 1.18774 4.4375C1.30384 4.4375 1.41518 4.48362 1.49727 4.56571L4.25024 7.31923L10.9407 0.628212C11.0228 0.546119 11.1341 0.5 11.2502 0.5C11.3663 0.5 11.4777 0.546119 11.5598 0.628212C11.6419 0.710305 11.688 0.821647 11.688 0.937743C11.688 1.05384 11.6419 1.16518 11.5598 1.24727Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.7f2d150234481852e446b3c2bdabf242.svg";
export { ForwardRef as ReactComponent };